<template>
  <section>
    <!--工具条-->
    <SchedulingBasisToolbar :buttonList="buttonList" @callFunction="callFunction"></SchedulingBasisToolbar>

    <!--列表-->
    <el-table :data="vehicleLineList" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column fixed="left" label="操作" width="180">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small"
              v-if="!item.IsHide && scope.row.IsScheduling === false && item.name === '排班'"
              @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
            <el-button type="text" style="padding-right:6px;" size="small"
              v-if="!item.IsHide && scope.row.IsScheduling === true && (item.name === '取消排班' || item.name === '编辑')"
              @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && item.name === '编辑顶班'"
              @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="DriverName" label="司机" width="120"></el-table-column>
      <el-table-column prop="LicensePlateNumber" label="车牌号" width="120"></el-table-column>
      <el-table-column prop="SelfMadeNumber" label="车辆自编号" width="120"></el-table-column>
      <el-table-column prop="ReplaceDriverName" label="顶班司机" width="120"></el-table-column>
      <el-table-column prop="ReplaceVehicleNumber" label="顶班车辆" width="120"></el-table-column>
      <el-table-column prop="FirstReplaceDateString" label="首次顶班时间" width="120"></el-table-column>
      <el-table-column prop="LineName" label="线路" width="120" sortable></el-table-column>
      <el-table-column prop="SchedulingTemplateName" label="排班模版" width="200" sortable></el-table-column>
      <el-table-column prop="ShiftName" label="班次" width="180" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--排班-->
    <el-dialog title="排班" :visible.sync="schedulingFormVisible" v-model="schedulingFormVisible"
      :close-on-click-modal="false" width="25%">
      <el-form :model="schedulingForm" label-width="80px" :rules="schedulingFormRules" ref="schedulingForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-input v-model="schedulingForm.DriverName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="LicensePlateNumber" label-width="110px">
            <el-input v-model="schedulingForm.LicensePlateNumber" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="schedulingForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模版" prop="SchedulingTemplateId" label-width="110px">
            <el-select style="width: 100%;" @change="schedulingTemplateChange"
              v-model="schedulingForm.SchedulingTemplateId" clearable placeholder="请选择发车模版">
              <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
                :label="item.DepartureTemplate">
                <span style="float: left">{{ item.DepartureTemplate }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
            <el-select style="width: 100%;" @change="shiftNameRules" v-model="schedulingForm.ShiftName" filterable
              placeholder="请选择班次名称">
              <el-option v-for="item in shiftNameList" :key="item" :value="item" :label="item">
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="schedulingFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="schedulingSubmit" :loading="schedulingLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑顶班-->
    <el-dialog title="编辑顶班" :visible.sync="editReplaceFormVisible" v-model="editReplaceFormVisible" :close-on-click-modal="false"
      width="25%">
      <el-form :model="editReplaceForm" label-width="80px"  ref="editReplaceForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-input v-model="editReplaceForm.DriverName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="LicensePlateNumber" label-width="110px">
            <el-input v-model="editReplaceForm.LicensePlateNumber" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="editReplaceForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="顶班司机" prop="ReplaceDriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="editReplaceForm.ReplaceDriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="顶班车辆" prop="ReplaceVehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="editReplaceForm.ReplaceVehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="首次顶班时间" prop="FirstReplaceDate" label-width="110px">
             <el-date-picker v-model="editReplaceForm.FirstReplaceDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editReplaceFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editReplaceSubmit" :loading="editReplaceLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getVehicleLineListPage, getDriverListPage, getVehiclesListPage, getClassSubitem, editVehicleLine,editReplaceVehicleLine, cancelScheduling, vehicleLineExportExcel, verifyShiftName, getSchedulingTemplateListPage } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import SchedulingBasisToolbar from "../../components/QueryToolbar/SchedulingBasisToolbar";

export default {
  components: { SchedulingBasisToolbar },
  data() {
    return {
      filters: {
        busLinesId: "",
        schedulingTemplateId: "",
        driverId: "",
        vehicleId: ""
      },
      buttonList: [],
      operationButtonList: [],
      vehicleLineList: [], //车辆线路关系列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      shiftNameList: [], //班次名称列表
      schedulingTemplateList: [], //排班模版列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      verifyShiftNameMsg:"",
      schedulingFormVisible: false, //排班界面是否显示
      schedulingLoading: false,
      schedulingFormRules: {
        ShiftName: [{ required: true, message: "班次名称不能为空", trigger: "blur" }]
      },
      //排班界面数据
      schedulingForm: {
        Id: 0,
        CancelSchedulingId: "",
        CreateBy: "",
        BusLinesId:0,
        DriverName: "",
        LicensePlateNumber: "",
        LineName: "",
        SchedulingTemplateId: "",
        ShiftName: ""
      },
      editReplaceFormVisible: false, //编辑顶班界面是否显示
      editReplaceLoading: false,
      editReplaceFormRules: {
        ShiftName: [{ required: true, message: "班次名称不能为空", trigger: "blur" }]
      },
      //编辑顶班界面数据
      editReplaceForm: {
        Id: 0,
        CancelSchedulingId: "",
        CreateBy: "",
        BusLinesId:0,
        DriverName: "",
        DriverId: 0,
        LicensePlateNumber: "",
        LineName: "",
        SchedulingTemplateId: "",
        ShiftName: "",
        VehicleId:0,
        FirstReplaceDate: ""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        schedulingTemplateId: item.schedulingTemplateId,
        driverId: item.driverId,
        vehicleId: item.vehicleId
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getVehicleLine();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getVehicleLine();
    },
    queryVehicleLine(){
      this.page = 1;
      this.getVehicleLine();
    },
    //获取车辆线路关系列表
    getVehicleLine() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        schedulingTemplateId: _this.filters.schedulingTemplateId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isScheduling: 'false',
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getVehicleLineListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.vehicleLineList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    getSchedulingTemplateList(busLinesId) {
      let para = {
        busLinesId: busLinesId
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
      });
    },
    // 排班模版改变触发
    schedulingTemplateChange(value) {
      let id = this.schedulingForm.Id;
      let busLinesId = this.schedulingForm.BusLinesId;
      let shiftName = this.schedulingForm.ShiftName;
      let cancelSchedulingId = ""; //如果班次名称已经排在其他数据上，获取该其他数据Id值并赋予cancelSchedulingId
      let para = {
        id: id,
        busLinesId: busLinesId,
        schedulingTemplateId: value === "" ? 0 : value,
        shiftName: shiftName
      };
      verifyShiftName(para).then(res => {
        this.verifyShiftNameMsg = "";

        if (res.data.success) {
          this.verifyShiftNameMsg = res.data.msg;
          cancelSchedulingId = res.data.response;
        }

        this.schedulingForm.CancelSchedulingId = cancelSchedulingId;
      });
    },
    //校验班次名称是否已经排在其他数据上
    shiftNameRules(value) {
      let schedulingTemplateId = this.schedulingForm.SchedulingTemplateId;
      let para = {
        id: this.schedulingForm.Id,
        busLinesId: this.schedulingForm.BusLinesId,
        schedulingTemplateId: schedulingTemplateId === "" ? 0 : schedulingTemplateId,
        shiftName: value
      };
      verifyShiftName(para).then(res => {
        this.verifyShiftNameMsg = "";

        if(res.data.success){
          this.verifyShiftNameMsg = res.data.msg;
          this.schedulingForm.CancelSchedulingId = res.data.response;
        }
      });
    },
    // 导出
    handleExportExcel(){
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        schedulingTemplateId: _this.filters.schedulingTemplateId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isScheduling: 'false',
        page: _this.page,
        pageSize: _this.pageSize
      };
      vehicleLineExportExcel(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        a.download = "首次排班依据(未排班).xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        resolve(err.response);
      })
      .catch((error) => {
        reject(error);
      });
    },
    // 排班
    handleScheduling(){
      this.schedulingFormVisible = true;
      this.schedulingForm = Object.assign({}, this.currentRow);
      this.schedulingForm.SchedulingTemplateId = this.schedulingForm.SchedulingTemplateId === 0 ? "" : this.schedulingForm.SchedulingTemplateId;
      this.getSchedulingTemplateList(this.schedulingForm.BusLinesId);
    },
    // 取消排班
    CancelScheduling(){
       this.$confirm("确认取消排班吗？", "提示", {}).then(() => {
        let para = Object.assign({}, this.currentRow);

        cancelScheduling(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.$emit('myevent',null);
            this.getVehicleLine();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    // 排班
    schedulingSubmit: function() {
      this.$refs.schedulingForm.validate(valid => {
        if (valid) {
          this.$confirm(this.verifyShiftNameMsg+"确认提交吗？", "提示", {}).then(() => {
            this.schedulingLoading = true;
            let para = Object.assign({}, this.schedulingForm);
            para.SchedulingTemplateId = para.SchedulingTemplateId === "" ? 0 : para.SchedulingTemplateId;

            editVehicleLine(para).then(res => {
              if (util.isEmt.format(res)) {
                this.schedulingLoading = false;
                return;
              }

              if (res.data.success) {
                this.schedulingLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["schedulingForm"].resetFields();
                this.schedulingFormVisible = false;
                this.$emit('myevent',null);
                this.getVehicleLine();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //显示编辑顶班界面
    handleReplaceEdit() {
      let row = this.currentRow;
      this.editReplaceFormVisible = true;
      this.editReplaceForm = Object.assign({}, row);      
    },
    //编辑顶班
    editReplaceSubmit: function() {
      this.$refs.editReplaceForm.validate(valid => {
        if (valid) {
          this.$confirm(this.verifyShiftNameMsg+"确认提交吗？", "提示", {}).then(() => {
            this.editReplaceLoading = true;
            let para = Object.assign({}, this.editReplaceForm);
            para.SchedulingTemplateId = para.SchedulingTemplateId === "" ? 0 : para.SchedulingTemplateId;

            editReplaceVehicleLine(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editReplaceLoading = false;
                return;
              }

              if (res.data.success) {
                this.editReplaceLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editReplaceForm"].resetFields();
                this.editReplaceFormVisible = false;
                this.$emit('myevent',null);
                this.getVehicleLine();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getShiftNameList(){
      let para = {
        id:1
      };
      getClassSubitem(para).then(res => {
        this.shiftNameList = res.data;
        this.shiftNameList.push("休息");
      });
    }
  },
  mounted() {
    this.getVehicleLine();
    this.getDriverList();
    this.getVehiclesList();
    this.getShiftNameList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
